<template>
  <svg
    width="180"
    height="180"
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M158.582 152.584C153.949 157.36 149.803 160.167 146.629 162.287C115.675 182.957 80.2906 176.999 69.3506 174.963C51.7004 171.678 36.8011 169.36 24 157.794C-5.08808 131.512 -3.67328 76.6872 18.5535 42.7254C21.1889 38.6985 43.3821 5.79932 78.843 1.16356C79.7103 1.0502 80.3574 0.985564 80.9242 0.925587C88.8727 0.0839673 117.941 -4.78433 148.122 20.5032C152.09 23.8276 158.476 29.8241 164.397 38.9696C186.048 72.4096 186.116 124.201 158.582 152.584Z"
      fill="url(#paint0_linear_5708_64763)"
    />
    <path
      d="M62.3362 162.917C62.3362 162.917 39.2194 176.014 16.5623 153.804C-4.7206 132.942 -0.816635 100.79 3.02762 82.1002C3.2279 81.1266 4.58079 81.0312 4.91737 81.9665C9.98552 96.0508 31.421 150.804 62.3362 162.917Z"
      fill="#BDD0FB"
    />
    <g opacity="0.48">
      <path
        d="M58.7166 164.309C57.9422 164.363 57.1776 164.374 56.4086 164.359C56.024 164.357 55.641 164.335 55.2568 164.319C54.873 164.3 54.4906 164.265 54.107 164.239C52.575 164.11 51.0502 163.892 49.5368 163.604C46.5131 163.014 43.5477 162.103 40.6904 160.919C37.8366 159.726 35.1045 158.23 32.5423 156.482C29.9889 154.72 27.6133 152.704 25.4253 150.5C23.2804 148.253 21.3477 145.818 19.5877 143.265L18.3459 141.301L17.7333 140.314L17.1779 139.295L16.0768 137.252C15.7417 136.556 15.422 135.852 15.0995 135.15C14.7792 134.447 14.4398 133.753 14.1792 133.025C13.9016 132.305 13.6179 131.588 13.3483 130.866C13.059 130.151 12.8452 129.41 12.6081 128.678C12.3744 127.944 12.1398 127.212 11.9183 126.476C11.5139 124.992 11.1605 123.496 10.8045 122.005C10.5184 120.497 10.2561 118.986 10.0157 117.476C10.0015 117.386 10.0627 117.302 10.1524 117.288C10.2335 117.275 10.3104 117.324 10.3348 117.399L10.3373 117.407C10.8092 118.862 11.2546 120.316 11.6843 121.771C11.9329 122.489 12.1888 123.204 12.4303 123.922L12.7927 124.999L12.9738 125.537L13.0643 125.805L13.1687 126.069C13.4503 126.772 13.7186 127.479 13.9879 128.184C14.2611 128.888 14.5109 129.601 14.8342 130.283C15.4557 131.658 16.0055 133.062 16.706 134.394L17.7033 136.417L18.8008 138.384L19.3446 139.37L19.9438 140.321L21.1346 142.23C22.8207 144.708 24.6764 147.066 26.7244 149.251C28.7947 151.412 31.0489 153.398 33.4823 155.144C35.9038 156.906 38.5069 158.423 41.2349 159.681C43.9595 160.949 46.8152 161.942 49.739 162.691C52.6678 163.396 55.6771 163.922 58.699 163.981L58.7084 163.981C58.7991 163.983 58.8712 164.058 58.8694 164.149C58.8677 164.234 58.8002 164.303 58.7166 164.309Z"
        fill="white"
      />
    </g>
    <path
      d="M15.6834 19.6421C14.1409 17.6659 10.9958 19.1733 11.5765 21.612C14.5631 34.1529 18.8255 56.1391 16.2882 71.0447C12.6637 92.3379 8.54965 153.157 64.4448 165.654C66.8804 166.199 69.085 164.086 68.6369 161.631C64.8827 141.062 48.7425 61.9937 15.6834 19.6421Z"
      fill="#91B3FA"
    />
    <g opacity="0.48">
      <path
        d="M23.5706 45.3517C24.3365 46.5294 24.9582 47.7774 25.5292 49.0508C26.1028 50.3233 26.5911 51.6308 27.0564 52.9468C27.9581 55.5889 28.6516 58.2983 29.219 61.0319L29.6092 63.0896C29.7371 63.7762 29.8243 64.4685 29.9339 65.1581C30.1632 66.5367 30.3048 67.9252 30.458 69.3133C30.4929 69.6607 30.5388 70.0073 30.5649 70.3552L30.6388 71.3994L30.7866 73.4885L30.8235 74.0109L30.8421 74.5339L30.8777 75.58L30.9485 77.673C31.016 80.4716 30.8963 83.2631 30.775 86.0377L30.3745 94.3389C30.2585 97.0982 30.1966 99.8534 30.2293 102.603L30.272 104.664L30.3642 106.72C30.3837 107.407 30.4504 108.089 30.4964 108.773L30.5718 109.798C30.5942 110.14 30.6414 110.48 30.675 110.82C31.2058 116.275 32.4004 121.646 34.2417 126.792C34.7453 128.062 35.1979 129.354 35.7872 130.589L36.2068 131.525L36.4165 131.992L36.5215 132.226L36.6387 132.455L37.5755 134.28C37.7342 134.583 37.8822 134.892 38.0487 135.19L38.5614 136.08L39.5869 137.86C39.9506 138.44 40.3304 139.01 40.7014 139.587L41.261 140.449C41.3555 140.592 41.4449 140.739 41.5436 140.879L41.8458 141.295L43.0551 142.96C43.2585 143.237 43.4543 143.519 43.6638 143.791L44.3111 144.592L45.6009 146.199L45.9231 146.602L46.2645 146.988L46.9488 147.76L48.3178 149.305C48.5402 149.568 48.7914 149.804 49.029 150.053L49.7508 150.792L51.195 152.27C51.684 152.756 52.1957 153.218 52.6952 153.693C56.706 157.483 61.0488 160.927 65.5499 164.161C65.5991 164.196 65.6108 164.264 65.5762 164.313C65.5428 164.36 65.4776 164.372 65.429 164.342C60.7345 161.38 56.2276 158.093 52.0357 154.417C51.5138 153.956 50.9762 153.51 50.4666 153.035L48.9601 151.582L48.2066 150.856C47.9583 150.61 47.6967 150.378 47.4631 150.119L46.0268 148.593L45.3085 147.83L44.9499 147.447L44.6099 147.048L43.2517 145.448L42.5749 144.646C42.3554 144.374 42.1492 144.09 41.9358 143.813L40.665 142.14C37.3165 137.642 34.6393 132.642 32.6164 127.395C30.6303 122.13 29.4059 116.59 28.8326 111.011C28.222 105.427 28.3026 99.8139 28.5593 94.2566C28.82 88.6971 29.3615 83.1778 29.374 77.6849L29.3561 75.6198L29.3472 74.5868L29.3419 74.0703L29.3184 73.5548L29.2247 71.4918L29.1778 70.4598C29.1609 70.116 29.1242 69.7739 29.0984 69.4307L28.9356 67.3718L28.8956 66.8568C28.8798 66.6854 28.8572 66.5149 28.8384 66.3439L28.7199 65.3184C28.6358 64.6353 28.5737 63.9483 28.4714 63.2678L28.1579 61.2264C27.704 58.5114 27.1449 55.8089 26.3782 53.1608C25.9898 51.8395 25.5774 50.522 25.0795 49.2365C24.5961 47.948 24.0599 46.6657 23.3883 45.4709L23.3846 45.4642C23.3551 45.4118 23.3737 45.3456 23.4261 45.316C23.4762 45.288 23.5395 45.3041 23.5706 45.3517Z"
        fill="white"
      />
    </g>
    <path
      d="M167.1 163.929H9.19152C8.63767 163.929 8.18457 163.476 8.18457 162.922C8.18457 162.368 8.63773 161.915 9.19152 161.915L32.8375 151.842L145.8 152.759L167.1 161.915C167.654 161.915 168.107 162.368 168.107 162.922C168.107 163.476 167.654 163.929 167.1 163.929Z"
      fill="url(#paint1_linear_5708_64763)"
    />
    <path
      d="M4.79597 12.595C4.22021 13.4737 5.28649 16.2581 5.50803 17.2564C6.7762 22.9712 6.91631 31.4042 8.18454 37.1191C12.6004 57.0184 48.3366 146.395 50.8865 157.886C50.8865 157.886 114.129 157.885 114.136 157.886C114.366 157.896 179.09 35.533 179.997 27.5034C180.125 26.3662 176.88 23.4068 176.86 22.2618C176.771 17.117 172.583 20.6207 169.772 21.8108C161.888 25.1489 153.338 27.7431 144.88 25.9869C134.54 23.8399 126.164 15.6137 116.3 11.6033C103.013 6.20138 88.0873 8.85905 74.5812 13.7286C65.7459 16.9142 56.8615 21.0703 47.5929 20.6087C40.2096 20.241 33.2627 16.9612 26.2492 14.426C22.7288 13.1535 19.115 12.0729 15.4197 11.6294C13.4521 11.3932 6.16573 10.5045 4.79597 12.595Z"
      fill="white"
      fill-opacity="0.4"
    />
    <path
      d="M166.376 169.985H5.53497C4.91753 169.985 4.41699 169.484 4.41699 168.866V163.564C4.41699 162.946 4.91753 162.446 5.53497 162.446H166.376C166.993 162.446 167.494 162.946 167.494 163.564V168.866C167.494 169.484 166.993 169.985 166.376 169.985Z"
      fill="url(#paint2_linear_5708_64763)"
    />
    <mask
      id="mask0_5708_64763"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="4"
      y="16"
      width="173"
      height="149"
    >
      <path
        d="M4.6668 20.0675C4.09189 20.9144 5.161 23.6007 5.38351 24.5637C6.65737 30.0764 7.93122 35.5891 9.20508 41.1018C13.6407 60.2972 50.8622 152.886 53.4235 163.97C53.4235 163.97 111.795 164.755 111.802 164.755C112.032 164.766 175.44 40.715 176.34 32.9722C176.467 31.8756 176.757 30.6663 176.736 29.5621C176.641 24.6003 172.457 27.9751 169.647 29.12C161.767 32.3315 153.22 34.8247 144.76 33.1226C134.419 31.0417 126.035 23.0999 116.167 19.2225C102.875 13.9996 87.952 16.5477 74.4512 21.2305C65.6194 24.2938 56.7394 28.2931 47.4706 27.8388C40.0871 27.4768 33.1372 24.3068 26.1213 21.8548C22.5998 20.6241 18.985 19.5783 15.2893 19.1469C13.3214 18.9173 6.03437 18.0528 4.6668 20.0675Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5708_64763)">
      <path
        d="M165.407 76.015C165.394 75.2894 164.806 74.6924 164.085 74.6924H136.845C136.115 74.6924 135.397 75.3206 135.397 76.056V141.789C135.397 142.143 135.6 142.482 135.849 142.732C136.097 142.982 136.466 143.122 136.817 143.121L165.298 143.043C165.653 143.042 166 142.898 166.248 142.643C166.495 142.387 166.635 142.035 166.628 141.678L165.407 76.015Z"
        fill="#91B3FA"
      />
      <g opacity="0.31">
        <path
          d="M145.345 82.4382L137.585 82.4277L137.523 78.4224H145.291L145.345 82.4382Z"
          fill="white"
        />
        <path
          d="M154.042 82.4362L146.29 82.4257L146.237 78.4224H153.997L154.042 82.4362Z"
          fill="white"
        />
        <path
          d="M162.732 82.4342L154.988 82.4237L154.943 78.4224H162.695L162.732 82.4342Z"
          fill="white"
        />
        <path
          d="M145.442 89.6273L137.696 89.6323L137.634 85.6531L145.388 85.6499L145.442 89.6273Z"
          fill="white"
        />
        <path
          d="M154.126 89.6219L146.387 89.6269L146.334 85.6497L154.08 85.6465L154.126 89.6219Z"
          fill="white"
        />
        <path
          d="M162.8 89.616L155.069 89.621L155.025 85.6458L162.763 85.6426L162.8 89.616Z"
          fill="white"
        />
        <path
          d="M145.538 96.7683L137.805 96.7764L137.744 92.8111L145.485 92.8047L145.538 96.7683Z"
          fill="white"
        />
        <path
          d="M154.207 96.7585L146.482 96.7667L146.429 92.8033L154.162 92.7969L154.207 96.7585Z"
          fill="white"
        />
        <path
          d="M162.866 96.7497L155.148 96.7579L155.104 92.7964L162.829 92.79L162.866 96.7497Z"
          fill="white"
        />
        <path
          d="M145.635 103.883L137.915 103.894L137.854 99.9423L145.582 99.9326L145.635 103.883Z"
          fill="white"
        />
        <path
          d="M154.288 103.87L146.576 103.881L146.523 99.9315L154.243 99.9219L154.288 103.87Z"
          fill="white"
        />
        <path
          d="M162.932 103.857L155.228 103.868L155.184 99.9207L162.895 99.9111L162.932 103.857Z"
          fill="white"
        />
        <path
          d="M145.732 110.973L138.026 110.988L137.965 107.05L145.679 107.037L145.732 110.973Z"
          fill="white"
        />
        <path
          d="M154.37 110.957L146.671 110.972L146.619 107.036L154.325 107.023L154.37 110.957Z"
          fill="white"
        />
        <path
          d="M163 110.941L155.309 110.956L155.265 107.021L162.963 107.009L163 110.941Z"
          fill="white"
        />
        <path
          d="M145.827 118.04L138.134 118.057L138.074 114.133L145.774 114.117L145.827 118.04Z"
          fill="white"
        />
        <path
          d="M154.451 118.02L146.766 118.038L146.713 114.115L154.406 114.1L154.451 118.02Z"
          fill="white"
        />
        <path
          d="M163.064 118L155.387 118.018L155.343 114.097L163.028 114.082L163.064 118Z"
          fill="white"
        />
        <path
          d="M145.923 125.082L138.243 125.102L138.183 121.191L145.87 121.172L145.923 125.082Z"
          fill="white"
        />
        <path
          d="M154.53 125.058L146.858 125.079L146.806 121.17L154.485 121.151L154.53 125.058Z"
          fill="white"
        />
        <path
          d="M163.131 125.036L155.467 125.056L155.423 121.149L163.095 121.13L163.131 125.036Z"
          fill="white"
        />
        <path
          d="M146.017 132.099L138.351 132.123L138.291 128.226L145.964 128.204L146.017 132.099Z"
          fill="white"
        />
        <path
          d="M154.609 132.073L146.951 132.096L146.899 128.201L154.565 128.179L154.609 132.073Z"
          fill="white"
        />
        <path
          d="M163.195 132.046L155.544 132.07L155.5 128.176L163.158 128.154L163.195 132.046Z"
          fill="white"
        />
        <path
          d="M146.111 139.093L138.457 139.12L138.397 135.236L146.058 135.211L146.111 139.093Z"
          fill="white"
        />
        <path
          d="M154.688 139.063L147.043 139.09L146.991 135.208L154.644 135.183L154.688 139.063Z"
          fill="white"
        />
        <path
          d="M163.259 139.033L155.621 139.06L155.577 135.179L163.222 135.154L163.259 139.033Z"
          fill="white"
        />
      </g>
      <path
        d="M62.6697 68.4389C62.6543 67.6195 61.9904 66.9453 61.1767 66.9453H30.4169C29.5922 66.9453 28.7822 67.6547 28.7822 68.4852V142.712C28.7822 143.112 29.0108 143.495 29.2917 143.777C29.5726 144.059 29.9888 144.217 30.3856 144.216L62.5466 144.128C62.9468 144.126 63.3386 143.964 63.6185 143.676C63.8984 143.388 64.0562 142.99 64.0487 142.587L62.6697 68.4389Z"
        fill="#7D97F4"
      />
      <g opacity="0.34">
        <path
          d="M40.0169 75.6919L31.2541 75.6801L31.1846 71.1572H39.9559L40.0169 75.6919Z"
          fill="white"
        />
        <path
          d="M49.8379 75.6896L41.0839 75.6778L41.0239 71.1572H49.7865L49.8379 75.6896Z"
          fill="white"
        />
        <path
          d="M59.6511 75.6874L50.9059 75.6756L50.8555 71.1572H59.6092L59.6511 75.6874Z"
          fill="white"
        />
        <path
          d="M40.1263 83.8107L31.3789 83.8163L31.3096 79.323L40.0656 79.3193L40.1263 83.8107Z"
          fill="white"
        />
        <path
          d="M49.9313 83.8045L41.1926 83.8102L41.1328 79.3191L49.88 79.3154L49.9313 83.8045Z"
          fill="white"
        />
        <path
          d="M59.7265 83.7979L50.9966 83.8035L50.9463 79.3147L59.6847 79.311L59.7265 83.7979Z"
          fill="white"
        />
        <path
          d="M40.2344 91.8733L31.5021 91.8825L31.4331 87.4047L40.1739 87.3975L40.2344 91.8733Z"
          fill="white"
        />
        <path
          d="M50.0214 91.8632L41.2979 91.8724L41.2383 87.3969L49.9702 87.3896L50.0214 91.8632Z"
          fill="white"
        />
        <path
          d="M59.8 91.8526L51.0852 91.8619L51.0352 87.3886L59.7583 87.3813L59.8 91.8526Z"
          fill="white"
        />
        <path
          d="M40.3431 99.908L31.6259 99.9208L31.5571 95.4585L40.2826 95.4478L40.3431 99.908Z"
          fill="white"
        />
        <path
          d="M50.1139 99.8932L41.4055 99.9059L41.3462 95.4459L50.063 95.4351L50.1139 99.8932Z"
          fill="white"
        />
        <path
          d="M59.8756 99.8792L51.1759 99.892L51.126 95.4341L59.834 95.4233L59.8756 99.8792Z"
          fill="white"
        />
        <path
          d="M40.4518 107.915L31.7497 107.931L31.6812 103.484L40.3916 103.47L40.4518 107.915Z"
          fill="white"
        />
        <path
          d="M50.2046 107.896L41.5113 107.913L41.4521 103.468L50.1539 103.454L50.2046 107.896Z"
          fill="white"
        />
        <path
          d="M59.9502 107.879L51.2655 107.895L51.2158 103.452L59.9088 103.438L59.9502 107.879Z"
          fill="white"
        />
        <path
          d="M40.56 115.894L31.8731 115.914L31.8047 111.483L40.5 111.465L40.56 115.894Z"
          fill="white"
        />
        <path
          d="M50.2963 115.872L41.618 115.892L41.5591 111.462L50.2457 111.444L50.2963 115.872Z"
          fill="white"
        />
        <path
          d="M60.0244 115.85L51.3548 115.869L51.3052 111.442L59.9832 111.424L60.0244 115.85Z"
          fill="white"
        />
        <path
          d="M40.6678 123.846L31.9958 123.869L31.9277 119.453L40.608 119.432L40.6678 123.846Z"
          fill="white"
        />
        <path
          d="M50.389 123.82L41.7257 123.843L41.667 119.429L50.3385 119.408L50.389 123.82Z"
          fill="white"
        />
        <path
          d="M60.0986 123.794L51.444 123.817L51.3945 119.405L60.0575 119.384L60.0986 123.794Z"
          fill="white"
        />
        <path
          d="M40.7742 131.77L32.1172 131.797L32.0493 127.396L40.7147 127.371L40.7742 131.77Z"
          fill="white"
        />
        <path
          d="M50.4779 131.74L41.8295 131.767L41.771 127.368L50.4277 127.343L50.4779 131.74Z"
          fill="white"
        />
        <path
          d="M60.172 131.71L51.5322 131.737L51.4829 127.34L60.131 127.315L60.172 131.71Z"
          fill="white"
        />
        <path
          d="M40.8815 139.668L32.2395 139.698L32.1719 135.312L40.8222 135.284L40.8815 139.668Z"
          fill="white"
        />
        <path
          d="M50.5683 139.634L41.9348 139.665L41.8765 135.281L50.5182 135.252L50.5683 139.634Z"
          fill="white"
        />
        <path
          d="M60.2458 139.6L51.6208 139.63L51.5718 135.249L60.2049 135.22L60.2458 139.6Z"
          fill="white"
        />
      </g>
      <path
        d="M111.84 104.723C111.828 104.35 111.334 104.042 110.728 104.042H87.8236C87.2095 104.042 86.6064 104.366 86.6064 104.744V138.55C86.6064 138.732 86.7767 138.906 86.9858 139.035C87.195 139.163 87.5049 139.235 87.8004 139.235L111.748 139.194C112.046 139.194 112.338 139.12 112.546 138.989C112.755 138.857 112.872 138.676 112.867 138.493L111.84 104.723Z"
        fill="#7D97F4"
      />
      <g opacity="0.06">
        <path
          d="M94.9722 108.026L88.4473 108.021L88.3955 105.961H94.9268L94.9722 108.026Z"
          fill="white"
        />
        <path
          d="M102.286 108.025L95.7673 108.02L95.7227 105.961H102.247L102.286 108.025Z"
          fill="white"
        />
        <path
          d="M109.593 108.024L103.081 108.019L103.043 105.961H109.562L109.593 108.024Z"
          fill="white"
        />
        <path
          d="M95.0525 111.724L88.5389 111.726L88.4873 109.68L95.0072 109.678L95.0525 111.724Z"
          fill="white"
        />
        <path
          d="M102.353 111.721L95.8462 111.723L95.8018 109.678L102.315 109.676L102.353 111.721Z"
          fill="white"
        />
        <path
          d="M109.646 111.718L103.146 111.72L103.108 109.676L109.615 109.674L109.646 111.718Z"
          fill="white"
        />
        <path
          d="M95.1347 115.395L88.6324 115.4L88.5811 113.36L95.0896 113.357L95.1347 115.395Z"
          fill="white"
        />
        <path
          d="M102.423 115.391L95.9271 115.395L95.8828 113.356L102.385 113.353L102.423 115.391Z"
          fill="white"
        />
        <path
          d="M109.703 115.386L103.214 115.39L103.177 113.353L109.672 113.35L109.703 115.386Z"
          fill="white"
        />
        <path
          d="M95.215 119.055L88.724 119.061L88.6729 117.028L95.17 117.023L95.215 119.055Z"
          fill="white"
        />
        <path
          d="M102.491 119.048L96.0066 119.054L95.9624 117.023L102.453 117.018L102.491 119.048Z"
          fill="white"
        />
        <path
          d="M109.759 119.042L103.281 119.048L103.244 117.018L109.728 117.013L109.759 119.042Z"
          fill="white"
        />
        <path
          d="M95.2963 122.702L88.8167 122.709L88.7656 120.684L95.2516 120.677L95.2963 122.702Z"
          fill="white"
        />
        <path
          d="M102.56 122.693L96.0866 122.701L96.0425 120.676L102.522 120.67L102.56 122.693Z"
          fill="white"
        />
        <path
          d="M109.815 122.685L103.349 122.692L103.312 120.669L109.785 120.663L109.815 122.685Z"
          fill="white"
        />
        <path
          d="M95.3768 126.336L88.9083 126.345L88.8574 124.327L95.3322 124.318L95.3768 126.336Z"
          fill="white"
        />
        <path
          d="M102.627 126.326L96.1655 126.335L96.1216 124.318L102.59 124.31L102.627 126.326Z"
          fill="white"
        />
        <path
          d="M109.869 126.316L103.414 126.325L103.377 124.308L109.839 124.3L109.869 126.316Z"
          fill="white"
        />
        <path
          d="M95.4573 129.957L89 129.968L88.9492 127.956L95.4127 127.947L95.4573 129.957Z"
          fill="white"
        />
        <path
          d="M102.696 129.945L96.2449 129.956L96.2012 127.945L102.658 127.936L102.696 129.945Z"
          fill="white"
        />
        <path
          d="M109.926 129.933L103.482 129.944L103.445 127.935L109.895 127.925L109.926 129.933Z"
          fill="white"
        />
        <path
          d="M95.5368 133.567L89.0906 133.579L89.04 131.575L95.4924 131.563L95.5368 133.567Z"
          fill="white"
        />
        <path
          d="M102.762 133.553L96.3219 133.566L96.2783 131.562L102.724 131.551L102.762 133.553Z"
          fill="white"
        />
        <path
          d="M109.98 133.539L103.546 133.551L103.51 131.549L109.949 131.538L109.98 133.539Z"
          fill="white"
        />
        <path
          d="M95.6182 137.163L89.1832 137.177L89.1328 135.179L95.574 135.167L95.6182 137.163Z"
          fill="white"
        />
        <path
          d="M102.83 137.148L96.4013 137.162L96.3579 135.165L102.793 135.152L102.83 137.148Z"
          fill="white"
        />
        <path
          d="M110.037 137.132L103.615 137.146L103.579 135.151L110.007 135.138L110.037 137.132Z"
          fill="white"
        />
      </g>
      <path
        d="M87.6308 80.5186C87.621 80.0765 87.1961 79.7207 86.6753 79.7207H55.0869C54.5591 79.7207 53.9985 80.0875 53.9985 80.5356V143.141C53.9985 143.475 54.2217 143.796 54.5006 144.032C54.7796 144.268 55.191 144.401 55.5849 144.4L87.5194 144.326C87.9167 144.325 88.3053 144.189 88.5832 143.947C88.8612 143.706 89.0177 143.379 89.0102 143.042L87.6308 80.5186Z"
        fill="url(#paint3_linear_5708_64763)"
      />
      <g opacity="0.7">
        <path
          d="M69.489 84.1576L59.1558 84.1272L59.1596 83.0293L69.4814 83.057L69.489 84.1576Z"
          fill="white"
        />
        <path
          d="M69.5174 88.2013L59.1416 88.1611L59.1455 87.0542L69.5096 87.0917L69.5174 88.2013Z"
          fill="white"
        />
        <path
          d="M69.5461 92.2791L59.1274 92.2289L59.1314 91.1128L69.5383 91.1602L69.5461 92.2791Z"
          fill="white"
        />
        <path
          d="M69.5741 96.3908L59.1123 96.3304L59.1163 95.2051L69.5662 95.2627L69.5741 96.3908Z"
          fill="white"
        />
        <path
          d="M69.6035 100.536L59.0981 100.466L59.1022 99.3311L69.5956 99.3989L69.6035 100.536Z"
          fill="white"
        />
        <path
          d="M69.662 108.932L59.0684 108.84L59.0724 107.686L69.6539 107.775L69.662 108.932Z"
          fill="white"
        />
        <path
          d="M69.7527 121.794L59.0239 121.669L59.0281 120.485L69.7444 120.607L69.7527 121.794Z"
          fill="white"
        />
        <path
          d="M69.6333 104.717L59.084 104.635L59.0881 103.491L69.6253 103.57L69.6333 104.717Z"
          fill="white"
        />
        <path
          d="M69.6925 113.183L59.0542 113.08L59.0583 111.917L69.6843 112.016L69.6925 113.183Z"
          fill="white"
        />
        <path
          d="M69.7224 117.47L59.0391 117.356L59.0432 116.183L69.7142 116.293L69.7224 117.47Z"
          fill="white"
        />
        <path
          d="M69.7833 126.154L59.0088 126.018L59.013 124.824L69.7749 124.957L69.7833 126.154Z"
          fill="white"
        />
        <path
          d="M69.8139 130.552L58.9932 130.404L58.9974 129.2L69.8054 129.345L69.8139 130.552Z"
          fill="white"
        />
        <path
          d="M69.8453 134.988L58.978 134.828L58.9822 133.614L69.8368 133.77L69.8453 134.988Z"
          fill="white"
        />
        <path
          d="M69.8762 139.462L58.9619 139.29L58.9661 138.065L69.8676 138.234L69.8762 139.462Z"
          fill="white"
        />
        <path
          d="M83.0373 84.1974L72.6392 84.1669L72.6279 83.0654L83.0143 83.0933L83.0373 84.1974Z"
          fill="white"
        />
        <path
          d="M83.1215 88.2545L72.6803 88.214L72.6689 87.1035L83.0983 87.1413L83.1215 88.2545Z"
          fill="white"
        />
        <path
          d="M83.2065 92.3455L72.7219 92.295L72.7104 91.1753L83.1831 91.2231L83.2065 92.3455Z"
          fill="white"
        />
        <path
          d="M83.2918 96.4701L72.7635 96.4093L72.752 95.2803L83.2683 95.3382L83.2918 96.4701Z"
          fill="white"
        />
        <path
          d="M83.3789 100.629L72.8066 100.558L72.7949 99.4194L83.3552 99.4877L83.3789 100.629Z"
          fill="white"
        />
        <path
          d="M83.5534 109.052L72.8917 108.96L72.8799 107.802L83.5293 107.892L83.5534 109.052Z"
          fill="white"
        />
        <path
          d="M83.822 121.957L73.0233 121.831L73.0112 120.644L83.7972 120.767L83.822 121.957Z"
          fill="white"
        />
        <path
          d="M83.466 104.823L72.8491 104.741L72.8374 103.593L83.4421 103.672L83.466 104.823Z"
          fill="white"
        />
        <path
          d="M83.6417 113.318L72.9347 113.214L72.9229 112.047L83.6174 112.147L83.6417 113.318Z"
          fill="white"
        />
        <path
          d="M83.7309 117.619L72.9783 117.505L72.9663 116.327L83.7064 116.439L83.7309 117.619Z"
          fill="white"
        />
        <path
          d="M83.9129 126.333L73.0679 126.196L73.0557 124.998L83.8879 125.132L83.9129 126.333Z"
          fill="white"
        />
        <path
          d="M84.0048 130.746L73.1129 130.597L73.1006 129.389L83.9796 129.535L84.0048 130.746Z"
          fill="white"
        />
        <path
          d="M84.098 135.197L73.1589 135.036L73.1465 133.818L84.0726 133.975L84.098 135.197Z"
          fill="white"
        />
        <path
          d="M84.1911 139.687L73.2044 139.514L73.1919 138.285L84.1655 138.455L84.1911 139.687Z"
          fill="white"
        />
      </g>
      <path
        d="M144.781 53.6958H135.271V145.694H144.781V53.6958Z"
        fill="#7D97F4"
      />
      <path
        d="M140.294 55.9976H96.1899V145.694H140.294V55.9976Z"
        fill="#91B3FA"
      />
      <path
        d="M140.294 55.9976H96.1899V62.4307H140.294V55.9976Z"
        fill="url(#paint4_linear_5708_64763)"
      />
      <path
        d="M140.294 103.343H96.1899V104.643H140.294V103.343Z"
        fill="url(#paint5_linear_5708_64763)"
      />
      <path
        d="M140.294 82.8721H96.1899V84.2923H140.294V82.8721Z"
        fill="url(#paint6_linear_5708_64763)"
      />
      <path
        d="M107.189 87.8921H100.972V99.5429H107.189V87.8921Z"
        fill="url(#paint7_linear_5708_64763)"
      />
      <path
        d="M106.82 88.4487H101.342V99.0854H106.82V88.4487Z"
        fill="url(#paint8_linear_5708_64763)"
      />
      <path
        d="M104.24 88.1177H103.849V99.3883H104.24V88.1177Z"
        fill="url(#paint9_linear_5708_64763)"
      />
      <path
        d="M106.902 93.4736H101.251V93.8327H106.902V93.4736Z"
        fill="url(#paint10_linear_5708_64763)"
      />
      <path
        d="M106.902 90.7993H101.251V91.0034H106.902V90.7993Z"
        fill="url(#paint11_linear_5708_64763)"
      />
      <path
        d="M106.902 96.5112H101.251V96.7153H106.902V96.5112Z"
        fill="url(#paint12_linear_5708_64763)"
      />
      <path
        d="M107.189 99.5791H101.091V99.9149H107.189V99.5791Z"
        fill="url(#paint13_linear_5708_64763)"
      />
      <path
        d="M107.308 99.1836H100.81V99.7589H107.308V99.1836Z"
        fill="url(#paint14_linear_5708_64763)"
      />
      <path
        d="M107.325 87.3169H100.826V87.8922H107.325V87.3169Z"
        fill="url(#paint15_linear_5708_64763)"
      />
      <path
        d="M120.88 87.8921H114.663V99.5429H120.88V87.8921Z"
        fill="url(#paint16_linear_5708_64763)"
      />
      <path
        d="M120.511 88.4487H115.033V99.0854H120.511V88.4487Z"
        fill="url(#paint17_linear_5708_64763)"
      />
      <path
        d="M117.931 88.1182H117.54V99.3888H117.931V88.1182Z"
        fill="url(#paint18_linear_5708_64763)"
      />
      <path
        d="M120.593 93.4736H114.942V93.8327H120.593V93.4736Z"
        fill="url(#paint19_linear_5708_64763)"
      />
      <path
        d="M120.593 90.7998H114.942V91.0038H120.593V90.7998Z"
        fill="url(#paint20_linear_5708_64763)"
      />
      <path
        d="M120.593 96.5112H114.942V96.7153H120.593V96.5112Z"
        fill="url(#paint21_linear_5708_64763)"
      />
      <path
        d="M120.88 99.5796H114.782V99.9154H120.88V99.5796Z"
        fill="url(#paint22_linear_5708_64763)"
      />
      <path
        d="M120.999 99.1836H114.5V99.7589H120.999V99.1836Z"
        fill="url(#paint23_linear_5708_64763)"
      />
      <path
        d="M121.015 87.3169H114.517V87.8922H121.015V87.3169Z"
        fill="url(#paint24_linear_5708_64763)"
      />
      <path
        d="M134.237 87.9136H128.02V99.5644H134.237V87.9136Z"
        fill="url(#paint25_linear_5708_64763)"
      />
      <path
        d="M133.868 88.4702H128.39V99.1069H133.868V88.4702Z"
        fill="url(#paint26_linear_5708_64763)"
      />
      <path
        d="M131.288 88.1392H130.896V99.4098H131.288V88.1392Z"
        fill="url(#paint27_linear_5708_64763)"
      />
      <path
        d="M133.95 93.4946H128.299V93.8537H133.95V93.4946Z"
        fill="url(#paint28_linear_5708_64763)"
      />
      <path
        d="M133.95 90.8208H128.299V91.0248H133.95V90.8208Z"
        fill="url(#paint29_linear_5708_64763)"
      />
      <path
        d="M133.95 96.5327H128.299V96.7368H133.95V96.5327Z"
        fill="url(#paint30_linear_5708_64763)"
      />
      <path
        d="M134.237 99.6006H128.139V99.9363H134.237V99.6006Z"
        fill="url(#paint31_linear_5708_64763)"
      />
      <path
        d="M134.356 99.2046H127.857V99.7799H134.356V99.2046Z"
        fill="url(#paint32_linear_5708_64763)"
      />
      <path
        d="M134.372 87.3384H127.874V87.9137H134.372V87.3384Z"
        fill="url(#paint33_linear_5708_64763)"
      />
      <path
        d="M140.294 125.32H96.1899V129.969H140.294V125.32Z"
        fill="url(#paint34_linear_5708_64763)"
      />
      <path
        d="M107.189 109.869H100.972V121.519H107.189V109.869Z"
        fill="url(#paint35_linear_5708_64763)"
      />
      <path
        d="M106.82 110.425H101.342V121.062H106.82V110.425Z"
        fill="url(#paint36_linear_5708_64763)"
      />
      <path
        d="M104.24 110.094H103.849V121.365H104.24V110.094Z"
        fill="url(#paint37_linear_5708_64763)"
      />
      <path
        d="M106.902 115.45H101.251V115.809H106.902V115.45Z"
        fill="url(#paint38_linear_5708_64763)"
      />
      <path
        d="M106.902 112.776H101.251V112.98H106.902V112.776Z"
        fill="url(#paint39_linear_5708_64763)"
      />
      <path
        d="M106.902 118.488H101.251V118.692H106.902V118.488Z"
        fill="url(#paint40_linear_5708_64763)"
      />
      <path
        d="M107.189 121.556H101.091V121.891H107.189V121.556Z"
        fill="url(#paint41_linear_5708_64763)"
      />
      <path
        d="M107.308 121.16H100.81V121.735H107.308V121.16Z"
        fill="url(#paint42_linear_5708_64763)"
      />
      <path
        d="M107.325 109.293H100.826V109.869H107.325V109.293Z"
        fill="url(#paint43_linear_5708_64763)"
      />
      <path
        d="M106.972 131.603H100.755V143.254H106.972V131.603Z"
        fill="url(#paint44_linear_5708_64763)"
      />
      <path
        d="M106.603 132.16H101.125V142.796H106.603V132.16Z"
        fill="url(#paint45_linear_5708_64763)"
      />
      <path
        d="M104.023 131.829H103.632V143.099H104.023V131.829Z"
        fill="url(#paint46_linear_5708_64763)"
      />
      <path
        d="M106.687 137.184H101.036V137.543H106.687V137.184Z"
        fill="url(#paint47_linear_5708_64763)"
      />
      <path
        d="M106.687 134.51H101.036V134.714H106.687V134.51Z"
        fill="url(#paint48_linear_5708_64763)"
      />
      <path
        d="M106.687 140.222H101.036V140.426H106.687V140.222Z"
        fill="url(#paint49_linear_5708_64763)"
      />
      <path
        d="M106.972 143.29H100.874V143.626H106.972V143.29Z"
        fill="url(#paint50_linear_5708_64763)"
      />
      <path
        d="M107.092 142.894H100.593V143.469H107.092V142.894Z"
        fill="url(#paint51_linear_5708_64763)"
      />
      <path
        d="M107.108 131.028H100.609V131.603H107.108V131.028Z"
        fill="url(#paint52_linear_5708_64763)"
      />
      <path
        d="M134.992 131.64H128.775V143.29H134.992V131.64Z"
        fill="url(#paint53_linear_5708_64763)"
      />
      <path
        d="M134.623 132.196H129.145V142.833H134.623V132.196Z"
        fill="url(#paint54_linear_5708_64763)"
      />
      <path
        d="M132.044 131.865H131.653V143.136H132.044V131.865Z"
        fill="url(#paint55_linear_5708_64763)"
      />
      <path
        d="M134.706 137.221H129.055V137.58H134.706V137.221Z"
        fill="url(#paint56_linear_5708_64763)"
      />
      <path
        d="M134.706 134.547H129.055V134.751H134.706V134.547Z"
        fill="url(#paint57_linear_5708_64763)"
      />
      <path
        d="M134.706 140.259H129.055V140.463H134.706V140.259Z"
        fill="url(#paint58_linear_5708_64763)"
      />
      <path
        d="M134.992 143.327H128.894V143.662H134.992V143.327Z"
        fill="url(#paint59_linear_5708_64763)"
      />
      <path
        d="M135.112 142.931H128.613V143.506H135.112V142.931Z"
        fill="url(#paint60_linear_5708_64763)"
      />
      <path
        d="M135.128 131.064H128.629V131.64H135.128V131.064Z"
        fill="url(#paint61_linear_5708_64763)"
      />
      <path
        d="M120.88 109.869H114.663V121.519H120.88V109.869Z"
        fill="url(#paint62_linear_5708_64763)"
      />
      <path
        d="M120.511 110.425H115.033V121.062H120.511V110.425Z"
        fill="url(#paint63_linear_5708_64763)"
      />
      <path
        d="M117.931 110.094H117.54V121.365H117.931V110.094Z"
        fill="url(#paint64_linear_5708_64763)"
      />
      <path
        d="M120.593 115.45H114.942V115.809H120.593V115.45Z"
        fill="url(#paint65_linear_5708_64763)"
      />
      <path
        d="M120.593 112.776H114.942V112.98H120.593V112.776Z"
        fill="url(#paint66_linear_5708_64763)"
      />
      <path
        d="M120.593 118.487H114.942V118.691H120.593V118.487Z"
        fill="url(#paint67_linear_5708_64763)"
      />
      <path
        d="M120.88 121.556H114.782V121.891H120.88V121.556Z"
        fill="url(#paint68_linear_5708_64763)"
      />
      <path
        d="M120.999 121.16H114.5V121.735H120.999V121.16Z"
        fill="url(#paint69_linear_5708_64763)"
      />
      <path
        d="M121.015 109.293H114.517V109.869H121.015V109.293Z"
        fill="url(#paint70_linear_5708_64763)"
      />
      <path
        d="M134.237 109.89H128.02V121.541H134.237V109.89Z"
        fill="url(#paint71_linear_5708_64763)"
      />
      <path
        d="M133.868 110.446H128.39V121.083H133.868V110.446Z"
        fill="url(#paint72_linear_5708_64763)"
      />
      <path
        d="M131.288 110.116H130.896V121.386H131.288V110.116Z"
        fill="url(#paint73_linear_5708_64763)"
      />
      <path
        d="M133.95 115.471H128.299V115.83H133.95V115.471Z"
        fill="url(#paint74_linear_5708_64763)"
      />
      <path
        d="M133.95 112.797H128.299V113.001H133.95V112.797Z"
        fill="url(#paint75_linear_5708_64763)"
      />
      <path
        d="M133.95 118.509H128.299V118.713H133.95V118.509Z"
        fill="url(#paint76_linear_5708_64763)"
      />
      <path
        d="M134.237 121.577H128.139V121.912H134.237V121.577Z"
        fill="url(#paint77_linear_5708_64763)"
      />
      <path
        d="M134.356 121.181H127.857V121.756H134.356V121.181Z"
        fill="url(#paint78_linear_5708_64763)"
      />
      <path
        d="M134.372 109.315H127.874V109.89H134.372V109.315Z"
        fill="url(#paint79_linear_5708_64763)"
      />
      <path
        d="M107.541 80.3985H100.834V67.8292C103.099 65.7453 105.504 65.7501 107.541 67.8292V80.3985Z"
        fill="url(#paint80_linear_5708_64763)"
      />
      <path
        d="M107.142 79.9049H101.232V68.4297C103.076 66.4571 105.345 66.525 107.142 68.4297V79.9049Z"
        fill="url(#paint81_linear_5708_64763)"
      />
      <path
        d="M104.359 66.8066H103.937V80.2321H104.359V66.8066Z"
        fill="url(#paint82_linear_5708_64763)"
      />
      <path
        d="M107.231 73.6392H101.135V74.0265H107.231V73.6392Z"
        fill="url(#paint83_linear_5708_64763)"
      />
      <path
        d="M107.231 70.543H101.135V70.7631H107.231V70.543Z"
        fill="url(#paint84_linear_5708_64763)"
      />
      <path
        d="M107.231 77.022H101.135V77.2421H107.231V77.022Z"
        fill="url(#paint85_linear_5708_64763)"
      />
      <path
        d="M107.541 80.4375H100.962V80.7997H107.541V80.4375Z"
        fill="url(#paint86_linear_5708_64763)"
      />
      <path
        d="M107.669 80.0107H100.658V80.6314H107.669V80.0107Z"
        fill="url(#paint87_linear_5708_64763)"
      />
      <path
        d="M120.997 80.3584H114.291V67.7891C116.556 65.7052 118.96 65.7101 120.997 67.7891V80.3584Z"
        fill="url(#paint88_linear_5708_64763)"
      />
      <path
        d="M120.599 79.8644H114.689V68.3891C116.532 66.4165 118.802 66.4845 120.599 68.3891V79.8644Z"
        fill="url(#paint89_linear_5708_64763)"
      />
      <path
        d="M117.816 66.7661H117.394V80.1916H117.816V66.7661Z"
        fill="url(#paint90_linear_5708_64763)"
      />
      <path
        d="M120.689 73.5991H114.592V73.9865H120.689V73.5991Z"
        fill="url(#paint91_linear_5708_64763)"
      />
      <path
        d="M120.689 70.5029H114.592V70.7231H120.689V70.5029Z"
        fill="url(#paint92_linear_5708_64763)"
      />
      <path
        d="M120.689 76.9814H114.592V77.2016H120.689V76.9814Z"
        fill="url(#paint93_linear_5708_64763)"
      />
      <path
        d="M120.997 80.397H114.418V80.7592H120.997V80.397Z"
        fill="url(#paint94_linear_5708_64763)"
      />
      <path
        d="M121.126 79.9702H114.115V80.5909H121.126V79.9702Z"
        fill="url(#paint95_linear_5708_64763)"
      />
      <path
        d="M134.457 80.3892H127.75V67.8199C130.016 65.736 132.42 65.7408 134.457 67.8199V80.3892Z"
        fill="url(#paint96_linear_5708_64763)"
      />
      <path
        d="M134.058 79.8956H128.148V68.4204C129.991 66.4478 132.261 66.5157 134.058 68.4204V79.8956Z"
        fill="url(#paint97_linear_5708_64763)"
      />
      <path
        d="M131.275 66.7974H130.853V80.2228H131.275V66.7974Z"
        fill="url(#paint98_linear_5708_64763)"
      />
      <path
        d="M134.147 73.6299H128.05V74.0172H134.147V73.6299Z"
        fill="url(#paint99_linear_5708_64763)"
      />
      <path
        d="M134.147 70.5342H128.05V70.7543H134.147V70.5342Z"
        fill="url(#paint100_linear_5708_64763)"
      />
      <path
        d="M134.147 77.0127H128.05V77.2328H134.147V77.0127Z"
        fill="url(#paint101_linear_5708_64763)"
      />
      <path
        d="M134.456 80.4277H127.877V80.7899H134.456V80.4277Z"
        fill="url(#paint102_linear_5708_64763)"
      />
      <path
        d="M134.585 80.0015H127.574V80.6221H134.585V80.0015Z"
        fill="url(#paint103_linear_5708_64763)"
      />
      <path
        d="M139.937 125.585H96.3818V129.728H139.937V125.585Z"
        fill="url(#paint104_linear_5708_64763)"
      />
      <path
        d="M121.016 130.491H113.515V145.694H121.016V130.491Z"
        fill="url(#paint105_linear_5708_64763)"
      />
      <path
        d="M117.014 131.027H113.85V133.521H117.014V131.027Z"
        fill="url(#paint106_linear_5708_64763)"
      />
      <path
        d="M120.527 131.027H117.604V133.521H120.527V131.027Z"
        fill="url(#paint107_linear_5708_64763)"
      />
      <path
        d="M120.526 133.843H113.85V145.426H120.526V133.843Z"
        fill="url(#paint108_linear_5708_64763)"
      />
      <path
        d="M119.065 135.219H115.325V140.734H119.065V135.219Z"
        fill="url(#paint109_linear_5708_64763)"
      />
      <path
        d="M118.823 135.438H115.566V140.566H118.823V135.438Z"
        fill="#91B3FA"
      />
      <path
        d="M117.376 135.317H117.148V140.68H117.376V135.317Z"
        fill="url(#paint110_linear_5708_64763)"
      />
      <path
        d="M118.985 136.819H115.432V137.047H118.985V136.819Z"
        fill="url(#paint111_linear_5708_64763)"
      />
      <path
        d="M118.971 138.776H115.419V139.004H118.971V138.776Z"
        fill="url(#paint112_linear_5708_64763)"
      />
      <path
        d="M96.1986 57.3757L92.6396 53.9974L138.967 53.6958L140.293 57.3757H96.1986Z"
        fill="url(#paint113_linear_5708_64763)"
      />
      <path
        d="M140.294 57.3757L138.968 53.6958H140.591L140.725 57.2387V62.3816L140.294 62.4309V57.3757Z"
        fill="url(#paint114_linear_5708_64763)"
      />
      <path
        d="M93.6611 54.9659L139.33 54.6992L139.631 55.5355L94.4668 55.7308L93.6611 54.9659Z"
        fill="#7D97F4"
      />
      <path
        d="M140.294 58.0635H96.1899V58.7001H140.294V58.0635Z"
        fill="#7D97F4"
      />
      <path
        d="M140.294 62.4312H96.1899V63.0439H140.294V62.4312Z"
        fill="#7D97F4"
      />
      <path
        d="M92.6396 53.9974L138.967 53.6958L139.076 53.9974L92.9592 54.3007L92.6396 53.9974Z"
        fill="url(#paint115_linear_5708_64763)"
      />
      <path
        d="M101.346 149.635H89.9331V141.025C89.9331 140.672 90.2199 140.385 90.5738 140.385H100.638C101.029 140.385 101.346 140.702 101.346 141.093V149.635Z"
        fill="url(#paint116_linear_5708_64763)"
      />
      <path
        d="M98.6858 140.018H93.2822C92.9989 140.018 92.7671 139.786 92.7671 139.503V133.2C92.7671 132.917 92.9989 132.685 93.2822 132.685H98.4689C98.7522 132.685 98.984 132.917 98.984 133.2V139.72C98.984 139.884 98.8505 140.018 98.6858 140.018Z"
        fill="url(#paint117_linear_5708_64763)"
      />
      <path
        d="M99.8376 140.072C99.8376 139.329 99.2302 138.722 98.4877 138.722H93.0168C92.2743 138.722 91.9155 139.329 91.9155 140.072V140.427H99.8376V140.072Z"
        fill="url(#paint118_linear_5708_64763)"
      />
      <path
        d="M97.8399 115.954C97.5511 115.721 96.8638 115.318 96.8746 114.894C96.5814 115.05 95.9244 114.665 95.7871 114.93C95.7043 115.089 95.481 115.086 95.3014 115.08C94.9709 115.07 94.6425 115.13 94.3171 115.189C94.2883 115.194 94.2566 115.201 94.2399 115.225C94.2193 115.255 94.2319 115.296 94.2454 115.329C94.5231 116.024 94.7304 116.66 94.7789 117.42C94.8233 118.116 94.9515 118.81 95.2005 119.463C95.709 120.798 96.8178 121.488 97.8802 122.356C97.9711 122.431 98.0633 122.51 98.1132 122.616C98.1697 122.736 98.1879 122.904 98.3151 122.942C98.3599 122.801 98.3337 122.649 98.3071 122.503C98.2165 122.006 98.1029 121.51 98.0644 121.006C98.027 120.517 98.0808 119.966 98.0106 119.531C98.102 119.534 98.1325 119.594 98.1503 119.683C98.3371 120.664 98.5392 121.643 98.7336 122.622C98.916 123.541 99.1022 124.389 98.8439 125.316C98.9176 125.361 98.9964 125.264 99.0207 125.182C99.045 125.099 99.0845 124.993 99.1704 124.997C99.27 125.002 99.2849 125.142 99.2747 125.241C99.2553 125.427 99.2206 125.717 99.2941 125.895C99.3384 126.003 99.3965 126.097 99.4899 126.146C99.5515 125.894 99.6556 125.645 99.724 125.39C99.7695 125.221 99.8059 125.045 99.7872 124.871C99.7378 124.411 99.5113 124.1 99.5214 123.631C99.5348 123.012 99.434 122.37 99.3791 121.753C99.2691 120.519 99.1313 119.287 98.9658 118.059C98.9151 117.683 98.8597 117.3 98.6941 116.959C98.5565 116.676 98.3484 116.433 98.1313 116.205C98.0736 116.144 97.9672 116.056 97.8399 115.954Z"
        fill="url(#paint119_linear_5708_64763)"
      />
      <path
        d="M94.8235 115.263C94.279 115.014 93.6893 115.043 93.1149 114.903C92.0688 114.65 91.2749 113.775 90.7755 112.822C90.5162 112.327 90.2767 111.872 90.193 111.336C90.1093 110.801 89.7243 110.518 89.8644 109.946C89.9042 109.783 90.0965 109.637 89.98 109.451C89.9197 109.355 89.7951 109.326 89.6833 109.306C89.4898 109.271 89.2963 109.235 89.1028 109.2C88.9892 109.179 88.8723 109.158 88.759 109.181C88.6458 109.203 88.5355 109.28 88.5083 109.392C88.4819 109.501 88.5368 109.611 88.5918 109.709C89.1998 110.786 89.2236 111.917 89.6529 113.052C90.09 114.206 90.9845 115.593 92.1481 116.125C92.7341 116.392 93.4016 116.447 93.9807 116.729C93.645 116.565 93.4996 118.497 93.5276 118.643C93.6345 119.199 93.9392 119.601 93.9484 120.19C93.9595 120.906 93.902 121.623 93.8818 122.338C93.8524 123.378 93.8207 124.434 93.755 125.468C93.6513 127.099 93.7931 128.782 93.8298 130.421C93.845 131.103 93.849 131.829 93.4887 132.408C93.5354 132.333 94.7558 132.561 94.9028 132.577C95.3749 132.627 95.8476 132.67 96.3209 132.708C96.7941 132.745 97.2679 132.776 97.742 132.8C98.0831 132.818 98.4643 132.94 98.7944 132.83C98.8067 132.448 98.4686 132.106 98.2583 131.816C97.7604 131.13 97.488 130.282 97.4925 129.435C97.4964 128.726 97.6866 128.033 97.8473 127.343C98.0392 126.519 98.1905 125.686 98.3006 124.847C98.3815 124.231 98.6563 123.271 98.4289 122.685C97.7771 121.003 97.2444 119.212 96.9235 117.433C96.888 117.235 96.8535 117.033 96.7558 116.858C96.6763 116.716 96.5591 116.599 96.4418 116.486C95.9831 116.042 95.4375 115.56 94.8644 115.282C94.8509 115.275 94.8372 115.269 94.8235 115.263Z"
        fill="url(#paint120_linear_5708_64763)"
      />
      <path
        d="M97.6259 113.622C97.6698 112.945 97.1736 112.261 96.518 112.087C96.1564 111.991 95.7385 112.09 95.4904 112.37C94.8712 113.069 95.2004 115.239 96.3375 115.291C96.8441 115.314 97.2728 114.55 97.4642 114.167C97.5225 114.051 97.5741 113.93 97.6012 113.802C97.6139 113.743 97.6221 113.682 97.6259 113.622Z"
        fill="url(#paint121_linear_5708_64763)"
      />
      <path
        d="M99.7176 134.139H92.0342C91.9001 134.139 91.7905 134.03 91.7905 133.896V132.5C91.7905 132.366 91.9002 132.256 92.0342 132.256H99.7176C99.8517 132.256 99.9613 132.366 99.9613 132.5V133.896C99.9613 134.03 99.8517 134.139 99.7176 134.139Z"
        fill="url(#paint122_linear_5708_64763)"
      />
      <path
        d="M89.5664 109.351C89.6501 109.323 99.5551 105.054 99.5551 105.054L100.504 105.305L100.058 105.948L89.8734 109.881L89.5664 109.351Z"
        fill="url(#paint123_linear_5708_64763)"
      />
      <path
        d="M88.7582 110.455L88.5015 109.856L89.7824 109.307L90.0391 109.906L88.7582 110.455Z"
        fill="url(#paint124_linear_5708_64763)"
      />
      <path
        d="M90.437 110.413L90.1261 110.518C90.0961 110.528 90.0637 110.512 90.0535 110.482L89.3927 108.519C89.3826 108.489 89.3987 108.456 89.4287 108.446L89.7395 108.341C89.7695 108.331 89.802 108.347 89.8121 108.377L90.473 110.341C90.4831 110.371 90.4669 110.403 90.437 110.413Z"
        fill="url(#paint125_linear_5708_64763)"
      />
      <path
        d="M95.3432 113.756C95.3342 113.98 95.4217 114.202 95.36 114.404C95.2604 114.404 95.0925 114.347 95.0211 114.268C94.7584 113.98 94.5241 113.77 94.4069 113.386C94.3305 113.136 94.301 112.869 94.3489 112.612C94.3969 112.355 94.5263 112.11 94.7292 111.946C94.9387 111.776 95.1458 111.83 95.3668 111.742C95.6023 111.649 95.749 111.4 95.9159 111.224C96.1264 111.001 96.4116 110.841 96.7169 110.816C97.0223 110.79 97.3445 110.911 97.5303 111.155C97.5823 111.223 97.6239 111.3 97.6855 111.36C97.8275 111.498 98.0652 111.542 98.2436 111.614C98.5711 111.744 98.7631 112.145 98.6604 112.482C98.5872 112.722 98.3854 112.883 98.338 113.134C98.2858 113.41 98.4338 113.69 98.338 113.963C98.2734 114.146 97.3183 114.987 97.1612 114.647C97.1517 114.627 97.1561 114.602 97.1611 114.58C97.2094 114.366 97.3237 114.208 97.2562 113.987C97.1921 113.778 97.018 113.63 96.9431 113.428C96.8894 113.284 96.9113 113.14 96.8616 112.996C96.7779 112.753 96.57 112.587 96.3298 112.513C95.8615 112.368 95.3094 112.606 95.3353 113.153C95.3444 113.345 95.3513 113.551 95.3432 113.756Z"
        fill="url(#paint126_linear_5708_64763)"
      />
      <path
        d="M48.2324 136.059C47.9447 133.467 48.9994 130.547 49.5759 127.841C49.8807 126.411 50.0523 124.986 49.8791 123.526C49.707 122.074 49.0916 120.486 49.7743 119.074C51.1497 116.228 54.0909 117.666 55.7185 119.915C57.6072 122.525 57.9854 126.68 58.6137 129.894C58.9925 131.831 59.6 133.827 59.762 135.792C60.0303 139.048 59.2078 141.268 57.5973 142.724C56.0526 144.122 53.7769 144.333 51.9993 143.248C50.3934 142.267 48.6965 140.24 48.2324 136.059Z"
        fill="#BDD0FB"
      />
      <path
        d="M54.6357 148.252C54.6558 148.243 54.6713 148.225 54.6762 148.202C54.9576 146.861 55.5391 143.18 55.7265 138.844C55.8641 135.662 55.78 132.585 55.4763 129.7C55.0966 126.093 54.3707 122.776 53.3188 119.842C53.3054 119.804 53.2643 119.785 53.2269 119.798C53.1892 119.811 53.17 119.853 53.1835 119.89C54.2313 122.813 54.9546 126.118 55.3332 129.714C55.6361 132.591 55.7202 135.66 55.583 138.835C55.3961 143.162 54.8161 146.835 54.5355 148.172C54.5274 148.211 54.5523 148.249 54.5911 148.257C54.6067 148.26 54.6221 148.258 54.6357 148.252Z"
        fill="#7D97F4"
      />
    </g>
    <path
      d="M126.832 174.235C126.832 174.235 127.168 176.141 127.333 178.027C127.398 178.764 126.829 179.404 126.09 179.435C123.578 179.54 118.206 179.743 116.278 179.657C115.988 179.644 115.799 179.347 115.906 179.078C115.996 178.852 116.169 178.669 116.39 178.568L125.265 174.489L126.832 174.235Z"
      fill="url(#paint127_linear_5708_64763)"
    />
    <path
      d="M127.106 173.116L126.835 175.395C126.835 175.395 125.281 176.119 124.219 175.304L124.863 172.764L127.106 173.116Z"
      fill="url(#paint128_linear_5708_64763)"
    />
    <path
      d="M126.903 130.267C127.02 130.863 127.53 159.969 124.419 173.012C124.368 173.225 124.476 173.444 124.678 173.527C125.156 173.722 126.091 174.004 127.212 174.042C127.559 174.054 127.871 173.828 127.968 173.495C128.858 170.468 133.119 155.306 133.675 140.822C134.296 124.637 133.675 140.271 133.675 140.271L133.311 130.266L126.903 130.267Z"
      fill="url(#paint129_linear_5708_64763)"
    />
    <path
      d="M137.04 175.229C137.04 175.229 137.576 176.191 138.095 178.747C138.188 179.209 137.866 179.651 137.397 179.697C136.568 179.779 135.291 179.883 134.268 179.876C133.797 179.873 133.429 179.463 133.486 178.994C133.599 178.061 133.952 176.531 135.042 175.338L137.04 175.229Z"
      fill="url(#paint130_linear_5708_64763)"
    />
    <path
      d="M137.51 172.298L136.879 175.745C136.879 175.745 136.254 176.209 135.018 175.872L135.32 172.164L137.51 172.298Z"
      fill="url(#paint131_linear_5708_64763)"
    />
    <path
      d="M139.218 131.16C141.762 146.517 138.666 169.116 137.622 173.539C137.558 173.809 137.339 174.017 137.065 174.062C136.599 174.14 135.831 174.203 135.075 173.983C134.814 173.907 134.631 173.672 134.62 173.401C134.48 169.825 134.732 147.872 132.361 139.196C132.241 138.757 131.973 138.373 131.601 138.109L127 134.837L126.647 129.549L139.218 131.16Z"
      fill="url(#paint132_linear_5708_64763)"
    />
    <path
      d="M123.003 102.063C130.629 101.937 139.042 104.065 139.042 104.065C141.315 117.328 139.439 132.626 139.439 132.626C133.536 134.174 126.877 131.679 126.877 131.679C125.896 126.136 121.318 110.534 121.318 110.534C117.593 110.071 114.524 108.997 111.996 107.575C113.924 105.341 114.833 102.497 115.228 100.816C117.924 101.654 120.652 102.101 123.003 102.063Z"
      fill="url(#paint133_linear_5708_64763)"
    />
    <path
      d="M100.481 90.8304C101.23 89.9256 102.178 90.3536 102.178 90.3536C103.3 95.0938 109.184 98.9372 115.228 100.816C114.834 102.497 113.925 105.341 111.997 107.575C101.965 101.935 100.481 90.8304 100.481 90.8304Z"
      fill="url(#paint134_linear_5708_64763)"
    />
    <path
      d="M100.663 91.0606C100.585 91.3098 101.492 91.6892 102.027 90.6701C102.045 90.1817 102.342 88.0891 102.051 87.6913C100.496 85.572 97.4827 82.9155 97.4827 82.9155C96.9734 83.4181 97.393 83.9118 97.393 83.9118L98.8548 85.4348C98.5491 85.9874 98.1761 86.4539 98.0012 87.1223C97.8689 87.6285 97.9499 88.1694 98.2055 88.63C98.4622 89.0924 98.8122 89.6934 99.1432 90.1637C99.7698 91.054 100.663 91.0606 100.663 91.0606Z"
      fill="url(#paint135_linear_5708_64763)"
    />
    <path
      d="M99.4944 86.4229L100.827 87.5523L101.245 88.6768L100.057 89.9945C100.057 89.9945 99.6577 87.7634 99.3608 87.2805C99.064 86.7976 99.2179 86.5641 99.4944 86.4229Z"
      fill="url(#paint136_linear_5708_64763)"
    />
    <path
      d="M136.118 111.448L139.042 104.064C139.042 104.064 146.165 108.904 147.336 115.04C145.99 115.139 143.541 115.489 141.144 116.7C140.618 113.802 136.118 111.448 136.118 111.448Z"
      fill="url(#paint137_linear_5708_64763)"
    />
    <path
      d="M129.894 118.396C129.894 118.396 137.89 122.916 140.588 119.057C141.149 118.255 141.283 117.459 141.145 116.7C143.542 115.489 145.99 115.139 147.336 115.04C147.689 116.89 147.503 118.857 146.416 120.846C141.689 129.492 128.835 120.368 128.835 120.368L129.894 118.396Z"
      fill="url(#paint138_linear_5708_64763)"
    />
    <path
      d="M130.857 124.115L126.492 108.873C126.443 108.7 126.295 108.574 126.117 108.553C125.326 108.461 123.035 108.202 120.389 107.978C117.203 107.708 113.502 107.49 111.291 107.676C110.977 107.702 110.787 108.035 110.927 108.317C112.184 110.862 117.356 121.211 119.947 124.601C120.032 124.713 120.165 124.779 120.306 124.778L130.432 124.683C130.727 124.681 130.938 124.398 130.857 124.115Z"
      fill="url(#paint139_linear_5708_64763)"
    />
    <path
      d="M129.803 120.432C129.803 120.432 130.41 117.932 130.165 117.045C129.92 116.158 129.445 115.018 127.861 115.271C126.277 115.525 124.409 116.192 124.409 116.192C124.409 116.192 124.504 117.347 125.707 116.974L124.961 117.552C124.961 117.552 125.067 118.477 126.084 117.983L125.39 118.749C125.39 118.749 125.827 119.509 126.575 119.021C127.323 118.534 127.681 120.733 129.803 120.432Z"
      fill="url(#paint140_linear_5708_64763)"
    />
    <path
      d="M130.727 95.8716L133.154 102.888C133.194 103.005 133.146 103.133 133.038 103.193C132.377 103.559 129.994 104.616 127.123 102.795C126.824 102.605 126.62 102.296 126.575 101.945L125.789 95.8716H130.727Z"
      fill="url(#paint141_linear_5708_64763)"
    />
    <path
      d="M125.449 89.374C125.449 89.374 122.784 94.3894 123.126 96.4154C123.467 98.4414 126.769 98.2959 129.653 96.6505L131.667 91.235L125.449 89.374Z"
      fill="url(#paint142_linear_5708_64763)"
    />
    <path
      d="M129.525 93.9906C129.408 93.9387 129.365 93.7953 129.435 93.688C129.648 93.362 130.048 92.6967 130.176 92.1142C130.176 92.1142 130.655 91.8075 128.957 91.401C127.259 90.9946 124.727 90.3637 124.195 88.9184C123.676 87.5092 125.039 83.9653 127.214 86.789C127.297 86.8965 127.459 86.8989 127.542 86.7914C127.899 86.3272 128.836 85.3639 130.138 85.9479C131.356 86.4945 131.493 87.387 131.476 87.8369C131.471 87.9693 131.589 88.0721 131.719 88.0473C132.335 87.9299 133.813 87.829 134.503 89.3451C135.071 90.5938 134.702 91.3007 134.365 91.6464C134.256 91.7584 134.304 91.9428 134.454 91.9885C134.858 92.1124 135.381 92.4557 135.329 93.4039C135.256 94.7148 133.791 94.5993 133.373 94.5395C133.305 94.5297 133.236 94.5532 133.19 94.6044C132.832 95.0004 131.22 96.6817 129.475 96.8843C129.324 96.9019 129.207 96.7527 129.257 96.6089L130.012 94.4139C130.047 94.312 129.998 94.2002 129.9 94.1565L129.525 93.9906Z"
      fill="url(#paint143_linear_5708_64763)"
    />
    <path
      d="M129.222 94.3022C129.222 94.3022 131.119 93.0007 131.257 94.0968C131.396 95.1928 129.549 95.6844 128.634 95.2758L129.222 94.3022Z"
      fill="url(#paint144_linear_5708_64763)"
    />
    <path
      d="M156.238 86.7773C156.238 86.7773 154.962 81.0529 161.518 82.5683C161.518 82.5683 164.701 82.0482 164.863 85.0524C164.863 85.0524 166.915 86.4043 165.412 89.0042C165.412 89.0042 171.509 86.6491 174.166 91.9935C176.822 97.3379 174.381 100.279 171.821 101.045C171.821 101.045 173.895 102.086 172.913 104.437C171.931 106.789 166.96 108.446 164.023 105.587C164.023 105.587 155.667 106.691 155.834 100.788C155.834 100.788 151.947 98.2783 156.03 93.4C160.112 88.5217 156.238 86.7773 156.238 86.7773Z"
      fill="url(#paint145_linear_5708_64763)"
    />
    <path
      d="M137.902 92.0654C138.031 91.8197 138.394 91.8584 138.468 92.1255C138.743 93.1144 139.408 94.84 140.803 95.4527C140.873 95.4836 140.94 95.5148 141.004 95.5462C141.068 95.3565 141.068 95.1362 140.917 94.9045C140.483 94.2415 141.266 93.3362 141.266 93.3362C141.266 93.3362 141.318 94.1336 141.924 94.6357C142.446 95.0682 142.697 96.0306 142.34 96.8201C141.585 99.7533 140.454 103.633 144.859 106.467C149.263 109.301 155.466 101.118 155.466 101.118L152.388 110.878C152.388 110.878 147.636 114.385 142.109 109.454C136.581 104.523 140.245 97.3475 140.245 97.3475C140.245 97.3475 136.029 95.6467 137.902 92.0654Z"
      fill="url(#paint146_linear_5708_64763)"
    />
    <path
      d="M155.877 100.045C157.195 99.6504 161.031 98.9211 164.68 102.289C165.299 102.86 165.552 103.728 165.331 104.54C164.351 108.149 161.765 118.81 164.032 123.422C164.032 123.422 160.037 127.827 155.678 124.277C155.678 124.277 153.722 115.753 151.16 112.01C149.391 109.427 153.98 102.308 155.141 100.589C155.317 100.328 155.576 100.136 155.877 100.045Z"
      fill="url(#paint147_linear_5708_64763)"
    />
    <path
      d="M159.516 92.877C159.516 92.877 161.465 98.3889 161.611 100.821C161.611 100.821 159.458 101.8 157.428 100.147C157.428 100.147 157.215 94.6414 156.908 93.6556L159.516 92.877Z"
      fill="url(#paint148_linear_5708_64763)"
    />
    <path
      d="M156.808 85.3614C156.808 85.3614 151.711 92.4942 154.758 94.5659C157.805 96.6378 161.433 91.5688 161.433 91.5688C161.433 91.5688 162.615 87.6648 161.379 86.3404C160.142 85.016 156.808 85.3614 156.808 85.3614Z"
      fill="url(#paint149_linear_5708_64763)"
    />
    <path
      d="M159.168 83.6567C159.168 83.6567 156.827 84.2114 156.499 85.2709C156.171 86.3304 159.819 87.3128 160.841 87.3608L161.665 91.6359C161.665 91.6359 164.1 87.6142 163.135 85.2916C162.171 82.9689 159.168 83.6567 159.168 83.6567Z"
      fill="url(#paint150_linear_5708_64763)"
    />
    <path
      d="M160.445 91.0436C160.445 91.0436 162.429 88.746 163.218 90.2439C164.007 91.7417 161.432 92.8662 160.541 92.1309L160.445 91.0436Z"
      fill="url(#paint151_linear_5708_64763)"
    />
    <path
      d="M150.589 142.175C150.604 142.562 149.924 145.632 149.555 147.269C149.406 147.928 149.509 148.617 149.845 149.204L162.65 170.757C162.805 171.018 162.918 171.3 162.987 171.596C163.221 172.607 163.708 175.086 163.454 177.341L162.791 178.717L165.656 178.066L166.28 170.372L165.469 169.878C164.768 169.45 164.222 168.812 163.91 168.053C162.752 165.24 159.877 158.08 159.135 154.59C158.293 150.625 153.889 147.403 153.889 147.403L154.663 145.574L150.589 142.175Z"
      fill="url(#paint152_linear_5708_64763)"
    />
    <path
      d="M168.842 175.42C168.842 175.42 167.295 172.967 167.112 172.012C166.93 171.057 166.424 169.371 165.47 169.878C165.47 169.878 165.02 174.517 165.175 176.329C165.33 178.142 163.127 178.083 163.127 178.083C163.127 178.083 162.519 178.169 162.074 178.613C161.767 178.921 161.987 179.453 162.42 179.481C163.141 179.528 164.287 179.54 165.49 179.307C165.91 179.226 166.222 178.869 166.247 178.441L166.565 173.103L168.516 175.567L168.842 175.42Z"
      fill="url(#paint153_linear_5708_64763)"
    />
    <path
      d="M158.239 145.609C158.239 145.609 158.691 164.888 158.752 167.627C158.813 170.365 158.32 176.433 155.575 178.247L156.769 179.131C156.769 179.131 158.262 177.862 159.72 175.421C161.358 172.678 161.853 172.177 161.853 172.177L161.31 171.063C161.072 170.576 161.002 170.025 161.111 169.493C161.704 166.622 163.683 157.073 164.222 155.017C164.859 152.589 164.905 149.348 162.688 146.634C160.471 143.92 158.239 145.609 158.239 145.609Z"
      fill="url(#paint154_linear_5708_64763)"
    />
    <path
      d="M160.774 180C160.859 180 160.932 179.939 160.944 179.855C161.035 179.212 161.415 176.636 161.727 175.968C162.083 175.204 163.247 171.988 161.726 171.715C161.726 171.715 157.944 177.241 157.218 177.986C156.492 178.731 155.575 178.246 155.575 178.246C155.575 178.246 154.868 178.455 154.334 179.137C154.08 179.462 154.317 179.938 154.729 179.942L157.277 179.966C158.016 179.973 158.682 179.524 158.957 178.837C159.405 177.717 160.176 176.074 161.073 175.345L160.607 179.812C160.597 179.912 160.674 179.999 160.774 180Z"
      fill="url(#paint155_linear_5708_64763)"
    />
    <path
      d="M155.075 122.199C155.075 122.199 155.649 124.029 154.767 127.043L149.296 146.15C149.21 146.45 149.372 146.764 149.666 146.869C151.302 147.457 156.682 149.117 164.026 148.611C164.396 148.585 164.706 148.323 164.786 147.962C165.27 145.783 166.921 138.352 167.261 136.825C168.556 131.006 170.003 124.731 163.64 120.937C160.708 122.193 157.973 122.933 155.075 122.199Z"
      fill="url(#paint156_linear_5708_64763)"
    />
    <path
      d="M165.202 103.009C165.202 103.009 171.427 108.183 172.972 115.252C174.517 122.322 163.876 123.073 163.876 123.073C163.876 123.073 162.431 121.46 160.716 122.035C159.001 122.61 160.583 119.22 162.59 119.228C164.596 119.237 163.667 120.824 166.506 119.538C169.271 118.286 170.98 114.412 163.925 108.539C163.516 108.199 163.189 107.765 162.993 107.271C161.622 103.82 162.709 101.558 165.202 103.009Z"
      fill="url(#paint157_linear_5708_64763)"
    />
    <path
      d="M67.9671 53.4454L45.9497 54.6952C44.1066 54.7999 42.5208 53.4057 42.3883 51.5642L40.5518 26.021C40.4112 24.0646 41.9604 22.3999 43.9217 22.3999H67.7755C69.6415 22.3999 71.1541 23.9126 71.1541 25.7787V50.072C71.1542 51.8638 69.7557 53.3439 67.9671 53.4454Z"
      fill="#91B3FA"
    />
    <path
      d="M55.8489 51.6495C54.7367 51.6495 53.7288 51.0814 53.1528 50.1296C49.9062 44.7657 46.0361 37.7009 46.0361 34.5059C46.0361 29.513 50.4381 25.4512 55.8489 25.4512C61.2596 25.4512 65.6616 29.513 65.6616 34.5059C65.6616 37.7012 61.7915 44.7658 58.5449 50.1298C57.9689 51.0813 56.9609 51.6495 55.8489 51.6495ZM55.8489 26.7068C51.1307 26.7068 47.292 30.2055 47.292 34.5059C47.292 36.7398 49.8198 42.1974 54.2272 49.4793C54.5738 50.0518 55.18 50.3935 55.8489 50.3935C56.5179 50.3935 57.1242 50.0518 57.4707 49.4792C61.8781 42.1975 64.4059 36.7399 64.4059 34.5059C64.4058 30.2056 60.5672 26.7068 55.8489 26.7068Z"
      fill="white"
    />
    <path
      d="M55.0879 40.8283C51.7332 40.8283 49.0039 38.099 49.0039 34.7441C49.0039 34.3972 49.285 34.1162 49.6318 34.1162C49.9786 34.1162 50.2597 34.3972 50.2597 34.7441C50.2597 37.4065 52.4256 39.5726 55.0879 39.5726C57.7502 39.5726 59.9161 37.4065 59.9161 34.7441C59.9161 32.0816 57.7502 29.9154 55.0879 29.9154C53.5484 29.9154 52.1368 30.6242 51.215 31.8602C51.0078 32.1383 50.6143 32.1955 50.3363 31.9881C50.0583 31.7807 50.001 31.3873 50.2084 31.1094C51.3525 29.5754 53.1766 28.6597 55.0879 28.6597C58.4427 28.6597 61.1719 31.3891 61.1719 34.7441C61.1719 38.099 58.4427 40.8283 55.0879 40.8283Z"
      fill="white"
    />
    <path
      d="M130.551 40.9123L107.644 40.5353C106 40.5082 104.711 39.1131 104.815 37.4718L106.322 13.5998C106.409 12.2257 107.455 11.1049 108.82 10.9241L128.783 9.32907C130.694 9.07591 134.723 11.4689 134.421 13.373L133.445 38.4825C133.22 39.9 131.986 40.936 130.551 40.9123Z"
      fill="#91B3FA"
    />
    <g opacity="0.9">
      <path
        d="M120.286 34.3542C115.318 34.3542 111.277 30.3125 111.277 25.3446C111.277 20.3767 115.318 16.335 120.286 16.335C125.254 16.335 129.295 20.3767 129.295 25.3446C129.295 30.3125 125.254 34.3542 120.286 34.3542ZM120.286 17.8447C116.151 17.8447 112.787 21.2091 112.787 25.3445C112.787 29.4799 116.151 32.8444 120.286 32.8444C124.421 32.8444 127.785 29.48 127.785 25.3445C127.785 21.2091 124.421 17.8447 120.286 17.8447Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.464 28.814V22.3367C117.464 21.6446 118.217 21.2156 118.812 21.5688L124.27 24.8074C124.853 25.1534 124.853 25.9973 124.27 26.3432L118.812 29.5819C118.217 29.9351 117.464 29.5061 117.464 28.814Z"
        fill="white"
      />
    </g>
    <path
      d="M55.8473 57.5719C55.6669 57.5719 55.5205 57.4255 55.5205 57.2451V55.9377C55.5205 55.7572 55.6669 55.6108 55.8473 55.6108C56.0278 55.6108 56.1741 55.7572 56.1741 55.9377V57.2451C56.1741 57.4255 56.0278 57.5719 55.8473 57.5719Z"
      fill="white"
    />
    <path
      d="M55.8473 62.7205C55.6669 62.7205 55.5205 62.5741 55.5205 62.3936V59.8195C55.5205 59.6391 55.6669 59.4927 55.8473 59.4927C56.0278 59.4927 56.1741 59.6391 56.1741 59.8195V62.3936C56.1741 62.574 56.0278 62.7205 55.8473 62.7205Z"
      fill="white"
    />
    <path
      d="M55.8473 66.6021C55.6669 66.6021 55.5205 66.4557 55.5205 66.2753V64.968C55.5205 64.7875 55.6669 64.6411 55.8473 64.6411C56.0278 64.6411 56.1741 64.7875 56.1741 64.968V66.2753C56.1741 66.4557 56.0278 66.6021 55.8473 66.6021Z"
      fill="white"
    />
    <path
      d="M119.766 43.5143C119.585 43.5143 119.439 43.3679 119.439 43.1875V41.8801C119.439 41.6996 119.585 41.5532 119.766 41.5532C119.946 41.5532 120.093 41.6996 120.093 41.8801V43.1875C120.093 43.3679 119.946 43.5143 119.766 43.5143Z"
      fill="white"
    />
    <path
      d="M119.766 48.6628C119.585 48.6628 119.439 48.5165 119.439 48.336V45.7619C119.439 45.5814 119.585 45.4351 119.766 45.4351C119.946 45.4351 120.093 45.5814 120.093 45.7619V48.336C120.093 48.5164 119.946 48.6628 119.766 48.6628Z"
      fill="white"
    />
    <path
      d="M119.766 52.5441C119.585 52.5441 119.439 52.3977 119.439 52.2173V50.9098C119.439 50.7294 119.585 50.583 119.766 50.583C119.946 50.583 120.093 50.7294 120.093 50.9098V52.2173C120.093 52.3977 119.946 52.5441 119.766 52.5441Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5708_64763"
        x1="196.263"
        y1="206.187"
        x2="70.7536"
        y2="72.5877"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5708_64763"
        x1="79.2208"
        y1="83.2321"
        x2="85.3223"
        y2="137.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5708_64763"
        x1="86.0655"
        y1="183.113"
        x2="86.5624"
        y2="259.373"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5708_64763"
        x1="97.7251"
        y1="67.989"
        x2="161.789"
        y2="-39.2127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5708_64763"
        x1="118.933"
        y1="80.0969"
        x2="117.9"
        y2="48.9088"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5708_64763"
        x1="125.996"
        y1="90.0686"
        x2="109.122"
        y2="120.364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5708_64763"
        x1="120.1"
        y1="64.53"
        x2="125.33"
        y2="10.9301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_5708_64763"
        x1="98.9869"
        y1="103.424"
        x2="106.755"
        y2="88.6233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_5708_64763"
        x1="115.334"
        y1="61.1685"
        x2="121.654"
        y2="42.8654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_5708_64763"
        x1="98.9733"
        y1="103.416"
        x2="106.741"
        y2="88.6158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_5708_64763"
        x1="98.9574"
        y1="103.409"
        x2="106.725"
        y2="88.6083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_5708_64763"
        x1="97.8255"
        y1="102.814"
        x2="105.593"
        y2="88.0135"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_5708_64763"
        x1="100.175"
        y1="104.048"
        x2="107.944"
        y2="89.2473"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_5708_64763"
        x1="105.212"
        y1="95.626"
        x2="103.76"
        y2="101.207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_5708_64763"
        x1="100.81"
        y1="99.4712"
        x2="107.308"
        y2="99.4712"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_5708_64763"
        x1="100.826"
        y1="87.6045"
        x2="107.325"
        y2="87.6045"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_5708_64763"
        x1="112.678"
        y1="103.424"
        x2="120.446"
        y2="88.6233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_5708_64763"
        x1="127.567"
        y1="65.3922"
        x2="133.887"
        y2="47.0891"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_5708_64763"
        x1="112.664"
        y1="103.417"
        x2="120.432"
        y2="88.6166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_5708_64763"
        x1="112.648"
        y1="103.409"
        x2="120.416"
        y2="88.6083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_5708_64763"
        x1="111.516"
        y1="102.814"
        x2="119.284"
        y2="88.014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_5708_64763"
        x1="113.866"
        y1="104.048"
        x2="121.635"
        y2="89.2473"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_5708_64763"
        x1="118.903"
        y1="95.6265"
        x2="117.451"
        y2="101.207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_5708_64763"
        x1="114.5"
        y1="99.4712"
        x2="120.999"
        y2="99.4712"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_5708_64763"
        x1="114.517"
        y1="87.6045"
        x2="121.015"
        y2="87.6045"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_5708_64763"
        x1="126.035"
        y1="103.445"
        x2="133.803"
        y2="88.6448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_5708_64763"
        x1="132.688"
        y1="86.1312"
        x2="129.137"
        y2="103.566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="0.4587" stop-color="#4792FB" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_5708_64763"
        x1="126.021"
        y1="103.438"
        x2="133.789"
        y2="88.6375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_5708_64763"
        x1="126.005"
        y1="103.43"
        x2="133.773"
        y2="88.6293"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_5708_64763"
        x1="124.873"
        y1="102.835"
        x2="132.641"
        y2="88.0349"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_5708_64763"
        x1="127.223"
        y1="104.069"
        x2="134.991"
        y2="89.2688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_5708_64763"
        x1="132.26"
        y1="95.6475"
        x2="130.808"
        y2="101.228"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_5708_64763"
        x1="127.857"
        y1="99.4922"
        x2="134.356"
        y2="99.4922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_5708_64763"
        x1="127.874"
        y1="87.626"
        x2="134.372"
        y2="87.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_5708_64763"
        x1="96.1899"
        y1="127.645"
        x2="140.294"
        y2="127.645"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_5708_64763"
        x1="98.9869"
        y1="125.4"
        x2="106.755"
        y2="110.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_5708_64763"
        x1="122.113"
        y1="63.5085"
        x2="128.432"
        y2="45.2055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_5708_64763"
        x1="98.9733"
        y1="125.393"
        x2="106.741"
        y2="110.592"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_5708_64763"
        x1="98.9574"
        y1="125.385"
        x2="106.726"
        y2="110.584"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_5708_64763"
        x1="97.8255"
        y1="124.79"
        x2="105.593"
        y2="109.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_5708_64763"
        x1="100.175"
        y1="126.024"
        x2="107.943"
        y2="111.224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_5708_64763"
        x1="105.212"
        y1="117.603"
        x2="103.76"
        y2="123.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_5708_64763"
        x1="100.81"
        y1="121.448"
        x2="107.308"
        y2="121.448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_5708_64763"
        x1="100.826"
        y1="109.581"
        x2="107.325"
        y2="109.581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_5708_64763"
        x1="98.7701"
        y1="147.135"
        x2="106.538"
        y2="132.334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_5708_64763"
        x1="128.623"
        y1="65.7565"
        x2="134.943"
        y2="47.4534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_5708_64763"
        x1="98.7567"
        y1="147.127"
        x2="106.525"
        y2="132.327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint47_linear_5708_64763"
        x1="98.7416"
        y1="147.119"
        x2="106.509"
        y2="132.319"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint48_linear_5708_64763"
        x1="97.6097"
        y1="146.526"
        x2="105.378"
        y2="131.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint49_linear_5708_64763"
        x1="99.9597"
        y1="147.758"
        x2="107.727"
        y2="132.958"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_5708_64763"
        x1="104.995"
        y1="139.337"
        x2="103.543"
        y2="144.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_5708_64763"
        x1="100.593"
        y1="143.182"
        x2="107.092"
        y2="143.182"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint52_linear_5708_64763"
        x1="100.609"
        y1="131.316"
        x2="107.108"
        y2="131.316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint53_linear_5708_64763"
        x1="126.79"
        y1="147.171"
        x2="134.558"
        y2="132.371"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint54_linear_5708_64763"
        x1="134.998"
        y1="116.653"
        x2="130.962"
        y2="143.693"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="0.4587" stop-color="#4792FB" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint55_linear_5708_64763"
        x1="126.778"
        y1="147.164"
        x2="134.546"
        y2="132.364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint56_linear_5708_64763"
        x1="126.761"
        y1="147.156"
        x2="134.529"
        y2="132.355"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint57_linear_5708_64763"
        x1="125.629"
        y1="146.561"
        x2="133.397"
        y2="131.761"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint58_linear_5708_64763"
        x1="127.979"
        y1="147.795"
        x2="135.747"
        y2="132.995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint59_linear_5708_64763"
        x1="133.015"
        y1="139.374"
        x2="131.563"
        y2="144.954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint60_linear_5708_64763"
        x1="128.613"
        y1="143.219"
        x2="135.112"
        y2="143.219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint61_linear_5708_64763"
        x1="128.629"
        y1="131.352"
        x2="135.128"
        y2="131.352"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint62_linear_5708_64763"
        x1="112.678"
        y1="125.4"
        x2="120.446"
        y2="110.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint63_linear_5708_64763"
        x1="134.346"
        y1="67.7323"
        x2="140.665"
        y2="49.4293"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint64_linear_5708_64763"
        x1="112.664"
        y1="125.393"
        x2="120.432"
        y2="110.593"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint65_linear_5708_64763"
        x1="112.648"
        y1="125.385"
        x2="120.417"
        y2="110.584"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint66_linear_5708_64763"
        x1="111.516"
        y1="124.79"
        x2="119.284"
        y2="109.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint67_linear_5708_64763"
        x1="113.866"
        y1="126.024"
        x2="121.634"
        y2="111.223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint68_linear_5708_64763"
        x1="118.903"
        y1="117.603"
        x2="117.451"
        y2="123.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint69_linear_5708_64763"
        x1="114.5"
        y1="121.448"
        x2="120.999"
        y2="121.448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint70_linear_5708_64763"
        x1="114.517"
        y1="109.581"
        x2="121.015"
        y2="109.581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint71_linear_5708_64763"
        x1="126.035"
        y1="125.422"
        x2="133.803"
        y2="110.621"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint72_linear_5708_64763"
        x1="133.579"
        y1="99.3501"
        x2="129.542"
        y2="126.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="0.4587" stop-color="#4792FB" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint73_linear_5708_64763"
        x1="126.021"
        y1="125.414"
        x2="133.789"
        y2="110.614"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint74_linear_5708_64763"
        x1="126.005"
        y1="125.406"
        x2="133.773"
        y2="110.606"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint75_linear_5708_64763"
        x1="124.873"
        y1="124.812"
        x2="132.641"
        y2="110.011"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint76_linear_5708_64763"
        x1="127.223"
        y1="126.046"
        x2="134.992"
        y2="111.245"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint77_linear_5708_64763"
        x1="132.26"
        y1="117.624"
        x2="130.808"
        y2="123.204"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint78_linear_5708_64763"
        x1="127.857"
        y1="121.469"
        x2="134.356"
        y2="121.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint79_linear_5708_64763"
        x1="127.874"
        y1="109.603"
        x2="134.372"
        y2="109.603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint80_linear_5708_64763"
        x1="98.646"
        y1="84.6733"
        x2="107.203"
        y2="68.3684"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint81_linear_5708_64763"
        x1="109.384"
        y1="59.114"
        x2="115.703"
        y2="40.8109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint82_linear_5708_64763"
        x1="98.1179"
        y1="85.0109"
        x2="107.355"
        y2="67.4106"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint83_linear_5708_64763"
        x1="98.6598"
        y1="84.3576"
        x2="107.04"
        y2="68.3903"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint84_linear_5708_64763"
        x1="97.4387"
        y1="83.5048"
        x2="105.819"
        y2="67.5375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint85_linear_5708_64763"
        x1="99.9739"
        y1="85.1527"
        x2="108.354"
        y2="69.1854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint86_linear_5708_64763"
        x1="105.408"
        y1="76.1728"
        x2="103.841"
        y2="82.1936"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint87_linear_5708_64763"
        x1="100.658"
        y1="80.321"
        x2="107.669"
        y2="80.321"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint88_linear_5708_64763"
        x1="112.103"
        y1="84.6332"
        x2="120.66"
        y2="68.3284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint89_linear_5708_64763"
        x1="121.395"
        y1="63.2605"
        x2="127.714"
        y2="44.9574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint90_linear_5708_64763"
        x1="111.574"
        y1="84.9703"
        x2="120.812"
        y2="67.3698"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint91_linear_5708_64763"
        x1="112.117"
        y1="84.3176"
        x2="120.498"
        y2="68.3502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint92_linear_5708_64763"
        x1="110.896"
        y1="83.4648"
        x2="119.276"
        y2="67.4975"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint93_linear_5708_64763"
        x1="113.431"
        y1="85.1122"
        x2="121.812"
        y2="69.1448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint94_linear_5708_64763"
        x1="118.865"
        y1="76.1322"
        x2="117.298"
        y2="82.1531"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint95_linear_5708_64763"
        x1="114.115"
        y1="80.2805"
        x2="121.126"
        y2="80.2805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint96_linear_5708_64763"
        x1="125.563"
        y1="84.664"
        x2="134.12"
        y2="68.3591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint97_linear_5708_64763"
        x1="133.43"
        y1="67.4167"
        x2="139.749"
        y2="49.1136"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint98_linear_5708_64763"
        x1="125.033"
        y1="85.0016"
        x2="134.271"
        y2="67.4013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint99_linear_5708_64763"
        x1="125.575"
        y1="84.3483"
        x2="133.956"
        y2="68.381"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint100_linear_5708_64763"
        x1="124.354"
        y1="83.496"
        x2="132.735"
        y2="67.5287"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint101_linear_5708_64763"
        x1="126.889"
        y1="85.1434"
        x2="135.27"
        y2="69.1761"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint102_linear_5708_64763"
        x1="132.324"
        y1="76.163"
        x2="130.757"
        y2="82.1839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDF53F" />
        <stop offset="1" stop-color="#D93C65" />
      </linearGradient>
      <linearGradient
        id="paint103_linear_5708_64763"
        x1="127.574"
        y1="80.3118"
        x2="134.585"
        y2="80.3118"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint104_linear_5708_64763"
        x1="118.159"
        y1="101.775"
        x2="118.159"
        y2="135.559"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint105_linear_5708_64763"
        x1="113.515"
        y1="138.093"
        x2="121.016"
        y2="138.093"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint106_linear_5708_64763"
        x1="115.736"
        y1="165.68"
        x2="115.494"
        y2="139.136"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="0.4587" stop-color="#4792FB" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint107_linear_5708_64763"
        x1="119.369"
        y1="165.647"
        x2="119.128"
        y2="139.103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="0.4587" stop-color="#4792FB" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint108_linear_5708_64763"
        x1="117.425"
        y1="165.664"
        x2="117.183"
        y2="139.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint109_linear_5708_64763"
        x1="115.325"
        y1="137.976"
        x2="119.065"
        y2="137.976"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint110_linear_5708_64763"
        x1="117.148"
        y1="137.999"
        x2="117.376"
        y2="137.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint111_linear_5708_64763"
        x1="115.432"
        y1="136.933"
        x2="118.985"
        y2="136.933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint112_linear_5708_64763"
        x1="115.419"
        y1="138.89"
        x2="118.971"
        y2="138.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint113_linear_5708_64763"
        x1="117.276"
        y1="80.152"
        x2="116.244"
        y2="48.9639"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint114_linear_5708_64763"
        x1="135.483"
        y1="57.4122"
        x2="142.884"
        y2="58.3838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint115_linear_5708_64763"
        x1="92.6396"
        y1="53.9983"
        x2="139.076"
        y2="53.9983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint116_linear_5708_64763"
        x1="98.895"
        y1="158.528"
        x2="95.8229"
        y2="146.065"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint117_linear_5708_64763"
        x1="102.95"
        y1="122.552"
        x2="99.7633"
        y2="128.804"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint118_linear_5708_64763"
        x1="96.2002"
        y1="138.834"
        x2="101.103"
        y2="119.332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint119_linear_5708_64763"
        x1="101.028"
        y1="117.441"
        x2="117.044"
        y2="104.967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint120_linear_5708_64763"
        x1="105.795"
        y1="112.294"
        x2="102.254"
        y2="114.854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint121_linear_5708_64763"
        x1="96.2953"
        y1="115.385"
        x2="96.6766"
        y2="108.739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint122_linear_5708_64763"
        x1="96.0463"
        y1="131.274"
        x2="97.4056"
        y2="115.926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint123_linear_5708_64763"
        x1="99.7633"
        y1="105.518"
        x2="110.385"
        y2="101.324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint124_linear_5708_64763"
        x1="-76.0658"
        y1="52.781"
        x2="-72.3487"
        y2="58.9046"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint125_linear_5708_64763"
        x1="174.497"
        y1="38.0864"
        x2="183.867"
        y2="30.1828"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="0.0653" stop-color="#4E51FD" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint126_linear_5708_64763"
        x1="100.903"
        y1="106.186"
        x2="96.6143"
        y2="112.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint127_linear_5708_64763"
        x1="121.607"
        y1="142.422"
        x2="121.607"
        y2="156.658"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint128_linear_5708_64763"
        x1="127.106"
        y1="174.228"
        x2="124.219"
        y2="174.228"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint129_linear_5708_64763"
        x1="-342.981"
        y1="-362.033"
        x2="-329.908"
        y2="-347.798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint130_linear_5708_64763"
        x1="135.795"
        y1="142.422"
        x2="135.795"
        y2="156.658"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint131_linear_5708_64763"
        x1="137.51"
        y1="174.08"
        x2="135.018"
        y2="174.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint132_linear_5708_64763"
        x1="-338.914"
        y1="-365.769"
        x2="-325.84"
        y2="-351.534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint133_linear_5708_64763"
        x1="144.752"
        y1="90.9702"
        x2="128.046"
        y2="115.664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint134_linear_5708_64763"
        x1="115.228"
        y1="98.9139"
        x2="100.481"
        y2="98.9139"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint135_linear_5708_64763"
        x1="103.766"
        y1="96.4419"
        x2="113.663"
        y2="118.958"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint136_linear_5708_64763"
        x1="100.552"
        y1="88.9429"
        x2="96.4226"
        y2="82.5942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint137_linear_5708_64763"
        x1="152.303"
        y1="96.0783"
        x2="135.598"
        y2="120.772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint138_linear_5708_64763"
        x1="147.499"
        y1="119.804"
        x2="128.836"
        y2="119.804"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint139_linear_5708_64763"
        x1="148.339"
        y1="78.3604"
        x2="121.755"
        y2="114.966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint140_linear_5708_64763"
        x1="130.224"
        y1="117.848"
        x2="124.409"
        y2="117.848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint141_linear_5708_64763"
        x1="133.168"
        y1="99.8513"
        x2="125.789"
        y2="99.8513"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint142_linear_5708_64763"
        x1="124.034"
        y1="95.157"
        x2="132.148"
        y2="90.2089"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint143_linear_5708_64763"
        x1="136.442"
        y1="84.9918"
        x2="125.96"
        y2="93.2698"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint144_linear_5708_64763"
        x1="126.165"
        y1="97.0023"
        x2="133.465"
        y2="92.5503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint145_linear_5708_64763"
        x1="181.989"
        y1="82.7509"
        x2="165.263"
        y2="93.9023"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint146_linear_5708_64763"
        x1="136.021"
        y1="85.1938"
        x2="152.582"
        y2="111.733"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint147_linear_5708_64763"
        x1="228.467"
        y1="63.8173"
        x2="193.604"
        y2="88.2197"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint148_linear_5708_64763"
        x1="156.416"
        y1="103.553"
        x2="159.521"
        y2="96.6577"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint149_linear_5708_64763"
        x1="156.255"
        y1="86.796"
        x2="162.556"
        y2="100.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint150_linear_5708_64763"
        x1="177.495"
        y1="76.0088"
        x2="160.768"
        y2="87.1603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint151_linear_5708_64763"
        x1="159.219"
        y1="85.4262"
        x2="165.52"
        y2="99.0671"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint152_linear_5708_64763"
        x1="194.234"
        y1="155.386"
        x2="160.825"
        y2="159.888"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint153_linear_5708_64763"
        x1="168.849"
        y1="174.688"
        x2="161.972"
        y2="174.623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint154_linear_5708_64763"
        x1="147.469"
        y1="158.444"
        x2="182.545"
        y2="170.028"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint155_linear_5708_64763"
        x1="162.461"
        y1="175.869"
        x2="154.264"
        y2="175.791"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint156_linear_5708_64763"
        x1="195.262"
        y1="116.971"
        x2="144.712"
        y2="143.117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint157_linear_5708_64763"
        x1="171.615"
        y1="125.004"
        x2="138.459"
        y2="75.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "OnboardingPropertyIcon",
};
</script>
